import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import SelectorHora from "../../general/SelectorHora";
import { getElementosHora } from "../../../../resources/Helper";

function EditarBloqueoUnidad() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [unidades, setUnidades] = useState([]);
    const [unidad, setUnidad] = useState([]);
    const [nombreUnidad, setNombreUnidad] = useState();
    const [descripcion, setDescripcion] = useState();
    const [horaInicio, setHoraInicio] = useState();
    const [horaFin, setHoraFin] = useState();
    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFin, setFechaFin] = useState();
    const [fechaFinRepeticion, setFechaFinRepeticion] = useState();
    const [frecuencia, setFrecuencia] = useState(0);

    const [showFechas, setShowFechas] = useState('hide');

    const [horaInicioBloqueo, setHoraInicioBloqueo] = useState();
    const [minutoInicioBloqueo, setMinutoInicioBloqueo] = useState();
    const [ampmInicioBloqueo, setAmpmInicioBloqueo] = useState();

    const [horaFinBloqueo, setHoraFinBloqueo] = useState();
    const [minutoFinBloqueo, setMinutoFinBloqueo] = useState();
    const [ampmFinBloqueo, setAmpmFinBloqueo] = useState();

    const [opcionesRepeticion, setOpcionesRepeticion] = useState([]);

    let history = useHistory();

    let userdata = [];

    const [errorlist, setErrorlist] = useState({});

    useEffect(()=>{ 

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/unidades-atencion?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUnidades(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });


        axios.get('/bloqueo-unidad',config2)
            .then(response => {

                setDescripcion(response.data[0].descripcion);
                setUnidad(response.data[0].id_unidad);
                setHoraInicio(response.data[0].hora_inicio);
                setHoraFin(response.data[0].hora_fin);
                setFechaInicio(response.data[0].fecha_inicio);
                setFechaFin(response.data[0].fecha_fin);
                setFrecuencia(response.data[0].frecuencia);
                setFechaFinRepeticion(response.data[0].fecha_fin_repeticion);

                let elementosHoraInicio = getElementosHora(response.data[0].hora_inicio);
                let elementosHoraFin = getElementosHora(response.data[0].hora_fin);

                setHoraInicioBloqueo(elementosHoraInicio[0]);
                setMinutoInicioBloqueo(elementosHoraInicio[1]);
                setAmpmInicioBloqueo(elementosHoraInicio[2]);

                setHoraFinBloqueo(elementosHoraFin[0]);
                setMinutoFinBloqueo(elementosHoraFin[1]);
                setAmpmFinBloqueo(elementosHoraFin[2]);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    useEffect(() => {
        if (frecuencia!=0) {
            setShowFechas('');
        }
        else {
            setShowFechas('hide');
        }
    },[frecuencia]);


    useEffect(() => {
        if (fechaInicio==fechaFin) {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos los días', visible: true },
                { value: 'semana', text: 'Cada semana', visible: true },
                { value: 'mes', text: 'Cada mes', visible: true }
            ]);
        }
        else {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos los días', visible: false },
                { value: 'semana', text: 'Cada semana', visible: true },
                { value: 'mes', text: 'Cada mes', visible: true }
            ]);
        }
    },[fechaFin]);


    useEffect(() => {
        for (let k=0;k<unidades.length;k++) {
            if (unidades[k].id==unidad) {
                setNombreUnidad(unidades[k].nombre_unidad);
                break;
            }
        }
    },[unidad]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            id:id,
            id_client: client.client_id,
            descripcion: descripcion,
            id_unidad: unidad,
            hora_inicio: horaInicio,
            hora_fin: horaFin,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            frecuencia: frecuencia,
            fecha_fin_repeticion: fechaFinRepeticion,
            fecha_hora_inicio: fechaInicio+" "+horaInicio,
            fecha_hora_fin: fechaFin+" "+horaFin
        };
        
        axios.put('/bloqueo-unidad', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','El bloqueo de la unidad ha sido modificado');
                    history.push('/bloqueos-unidades');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/bloqueos-unidades">Bloqueos de Unidades</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Editar Bloqueo</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Bloqueo de Unidad de Atención</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit} autoComplete={'off'}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="descripcion">Descripción del bloqueo</label>
                                                                <input 
                                                                    type="text" 
                                                                    name="descripcion" 
                                                                    className="form-control" 
                                                                    id="descripcion" 
                                                                    defaultValue={descripcion} 
                                                                    onChange={(e) => setDescripcion(e.target.value)}
                                                                    required
                                                                    disabled={loading}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="codigo">Unidad a bloquear</label>
                                                                <select name="codigo" className="form-control" id="codigo" value={unidad} onChange={(e) => setUnidad(e.target.value)}>
                                                                    <option key={'pf0'}></option>
                                                                    {
                                                                        unidades.map((uni) => 
                                                                            <option key={'pf'+uni.id} value={uni.id}>{uni.nombre_unidad}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.id_unidad}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaInicio">Fecha inicio</label>
                                                                <input type="date" name="fechaInicio" className="form-control" id="fechaInicio" defaultValue={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_inicio}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaInicio">Hora de inicio</label>
                                                                <SelectorHora onChange={setHoraInicio} horaAtencionCita={horaInicioBloqueo} minutoCita={minutoInicioBloqueo} ampmCita={ampmInicioBloqueo} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_hora_inicio}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Fecha finalización</label>
                                                                <input type="date" name="fechaFin" className="form-control" id="fechaFin" defaultValue={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_fin}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaFin">Hora de finalización</label>
                                                                <SelectorHora onChange={setHoraFin} horaAtencionCita={horaFinBloqueo} minutoCita={minutoFinBloqueo} ampmCita={ampmFinBloqueo} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_hora_fin}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Repetir este bloqueo:</label>
                                                                <select name="frecuencia" className="form-control" id="frecuencia" defaultValue={frecuencia} onChange={(e) => setFrecuencia(e.target.value)}>
                                                                    {
                                                                        opcionesRepeticion.map((opcion) => {
                                                                            return opcion.visible ? <option value={opcion.value}>{opcion.text}</option> : '';
                                                                        })
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.frecuencia}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'row '+showFechas}>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFinRepeticion">Fecha fin repetición</label>
                                                                <input type="date" name="fechaFinRepeticion" className="form-control" id="fechaFinRepeticion" defaultValue={fechaFinRepeticion} onChange={(e) => setFechaFinRepeticion(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_fin_repeticion}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Link to="/bloqueos-unidades" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Guardar cambios
                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>

                                    </form>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarBloqueoUnidad;